// important components
import initAnimations from './components/animations.js';
import siteNavigation from './components/navigation.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize animations
  initAnimations();

  // Initialize site navigation
  siteNavigation();

  // Initialize the loader function
  loader();

  diagramLineCalculation();

  window.addEventListener('resize', function () {
    diagramLineCalculation();
  });
});

function diagramLineCalculation() {
  // check if the care diagram exists on the page before trying to calculate its dimensions
  if (!document.querySelector('.care__diagram-vertical')) {
    return;
  }
  //  we calculate the height of the top and bottom cards in the care section to position the vertical line correctly
  const careTopcard = document.querySelector('.care__top');
  const careBottomcard = document.querySelector('.care__bottom');
  const careDiagramTop = document.querySelector('.care__diagram-vertical');

  const careTopCardHeightHalf = careTopcard.getBoundingClientRect().height / 2;
  const careBottomCardHeightHalf = careBottomcard.getBoundingClientRect().height / 2;
  // we position the vertical line to start at the bottom of the top card and end at the top of the bottom card
  careDiagramTop.style.top = `${careTopCardHeightHalf - 4}px`;
  // we set the height of the vertical line to be the distance between the bottom of the top card and the top of the bottom card
  careDiagramTop.style.height = `calc(100% - ${careBottomCardHeightHalf}px - ${careTopCardHeightHalf}px + 8px)`;
}

// global or one time use stuff
function loader() {
  // Your loader implementation
}
